if (!customElements.get("plp-view-toggle")) {
  customElements.define(
    "plp-view-toggle",
    class PlpViewToggle extends HTMLElement {
      constructor() {
        super();

        this.cookieName = "plp-view-mode";
        this.allowedViews = ["project", "product"];
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.collectionBody = this.closest(".collection__body");
        this.buttons = this.querySelectorAll("[data-plp-view]");

        if (!this.collectionBody || !this.buttons.length) return;

        this.addEventListener("click", this.handleClick);
        this.setView(this.getStoredView(), false);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
      }

      handleClick(event) {
        const button = event.target.closest("[data-plp-view]");
        if (!button || !this.contains(button)) return;
        this.setView(button.dataset.plpView);
      }

      getStoredView() {
        const cookie = document.cookie
          .split("; ")
          .find((cookie) => cookie.startsWith(`${this.cookieName}=`));

        const storedView = cookie ? cookie.split("=")[1] : null;

        return this.allowedViews.includes(storedView) ? storedView : "project";
      }

      setView(view, persist = true) {
        if (!this.allowedViews.includes(view)) return;

        this.collectionBody.dataset.plpView = view;
        this.buttons.forEach((button) => {
          const isActive = button.dataset.plpView === view;

          button.classList.toggle("active", isActive);
          button.setAttribute("aria-pressed", String(isActive));
        });

        if (persist) {
          const cookieDurationDays = 7;
          const cookieExpiration = new Date();
          cookieExpiration.setDate(
            cookieExpiration.getDate() + cookieDurationDays,
          );

          document.cookie = `${this.cookieName}=${view}; Expires=${cookieExpiration.toUTCString()}; Path=/; SameSite=Lax`;
        }

        this.dispatchEvent(new CustomEvent("plp:view-change", {
          bubbles: true,
          detail: {
            view: view,
          },
        }));
      }
    },
  );
}
